var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"surface1"},React.createElement("path",{"style":{"stroke":"none","fillRule":"nonzero","fill":"rgb(12.54902%,20.784314%,24.313725%)","fillOpacity":"1"},"d":"M 19.382812 21.449219 L 30.398438 32.925781 L 41.414062 21.449219 L 44.800781 25 L 30.398438 40 L 16 25 Z M 19.382812 21.449219 "})));
}

ChevronDown.defaultProps = {"width":"60px","height":"60px","viewBox":"0 0 60 60","version":"1.1"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
